import FormMessageHandler from '../components/formMessageHandler';
import Recaptcha from "../components/recaptcha";

if ($('body').hasClass("page--education_apply")) {
  let cacoo = require('../components/cacoo').cacoo;
  let Spinner = require('spin');

  class EducationApply {
    constructor() {
      this.body = $('body');
      this.form = $('#applicationForm', this.body);
      this.fullName = $('input[name="name"]', this.form);
      this.email = $('input[name="email"]', this.form);
      this.institution = $('input[name="institution"]', this.form);
      this.privacy = $('input#privacyPolicy', this.form);
      this.privacyError = $('#privacyPolicyError', this.form);
      this.plan = $('input[name="plan"]', this.form);
      this.planDropdown = $('.js_floating-label-input__dropdown', this.form);
      this.planDropdownItems = $('.js_floating-label-input__dropdown__item__inner', this.form);
      this.comments = $('textarea[name="comments"]', this.form);
      this.submitButton = $('button[type="submit"]');
      this.formMessageHandler = new FormMessageHandler(this.form);
      this.buttonSpinner = new Spinner({color: '#fff', lines: 12});
      this.recaptchaToken = $('input[name="recaptchaToken"]', this.form);
      this.recaptcha = new Recaptcha(this.recaptchaToken);

      this.successOverlay = $('.education_success__overlay');
      this.successMessage = $('.education__success');

      this.planKey = '';

      this.attachEvent();
    }

    attachEvent() {
      this.email.on('focusout', () => {
        this.emailValidation();
      });
      this.institution.on('focusout', () => {
        this.institutionValidation();
      });
      this.fullName.on('focusout', () => {
        this.nameValidation();
      });
      this.plan.on('click', (e) => {
        e.stopImmediatePropagation();
        this.toggleDropdown();
      });
      this.planDropdownItems.on('click', (e) => {
        e.stopImmediatePropagation();
        this.selectDropdownItem(e.currentTarget);
      });
      this.privacy.on('click', () => {
        this.privacyError.hide();
      });
      this.submitButton.on('click', (e) => {
        e.preventDefault();
        if (this.checkAllFields()) {
          this.submitForm();
        }
        return false;
      });

    }

    emailValidation() {
      if (!cacoo.util.validateEmail(this.email.val())) {
        this.formMessageHandler.showError('email', Cacoo.SiteResources['modal_signup_email_error']);
        return false;
      } else {
        this.formMessageHandler.showSuccess(['email']);
        return true;
      }
    }

    institutionValidation() {
      let error;
      if (this.institution.val().length < 1) {
        error = Cacoo.SiteResources["modal_education_signup_school_name_error"];
      } else if (this.institution.val().length > 100) {
        error = Cacoo.SiteResources["modal_education_signup_school_name_length_error"];
      }
      if (error != null) {
        this.formMessageHandler.showError('institution', error);
        return false;
      } else {
        this.formMessageHandler.showSuccess(['institution']);
        return true;
      }
    }

    nameValidation() {
      if (this.fullName.val().length < 1) {
        this.formMessageHandler.showError('name', Cacoo.SiteResources["modal_signup_name_error"]);
        return false;
      } else {
        this.formMessageHandler.showSuccess(['name']);
        return true;
      }
    }

    planValidation() {
      if (this.planKey.length < 1) {
        this.formMessageHandler.showError('plan', Cacoo.SiteResources["modal_education_signup_plan_error"]);
        return false;
      } else {
        this.formMessageHandler.showSuccess(['plan']);
        return true;
      }
    }

    privacyValidate() {
      if (this.privacy.length > 0) {
        const isChecked = this.privacy.is(":checked");
        this.privacyError.toggle(!isChecked);
        return isChecked;
      }
      return true;
    }

    checkAllFields() {
      return this.emailValidation() && this.nameValidation() && this.planValidation() && this.privacyValidate();
    }

    getFormData() {
      return {
        email: this.email.val(),
        name: this.fullName.val(),
        institution: this.institution.val(),
        planKey: this.planKey,
        comments: this.comments.val(),
        recaptchaToken: this.recaptchaToken.val()
      }
    }

    submitForm() {
      if (this.submitButton.hasClass('disable')) {
        return false;
      }

      this.recaptcha.check().then(() => {
        this.startButtonSpinner();
        let data = this.getFormData();
        cacoo.ajax({
          url: this.form.attr('action'),
          method: "POST",
          data: data,
          success: () => {
            this.stopButtonSpinner();
            this.submitForm_load();
          },
          error: (err) => {
            this.stopButtonSpinner();
            this.recaptcha.reset();

            //If backend returns error message
            if (err.errors) {
              this.formMessageHandler.showError(err.errors.field, err.errors);
              return
            } else {
              this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signup_default_error']);
            }
            return false;
          },
          timeout: 30000
        });
      }, () => {
        this.recaptcha.reset();
        this.stopButtonSpinner();
      });

    }

    submitForm_load() {
      this.successMessage.html(Cacoo.SiteResources["education_plan_complete"]);
      $.Velocity.animate(this.successOverlay, {
        opacity: .8
      }, {
        visibility: "visible"
      });
      $.Velocity.animate(this.successMessage, {
        opacity: 1
      }, {
        visibility: "visible"
      });
    }

    startButtonSpinner() {
      this.submitButton.addClass('disable');
      this.buttonSpinner.spin(this.submitButton.get(0));
    }

    stopButtonSpinner() {
      this.submitButton.removeClass('disable');
      this.buttonSpinner.stop();
    }

    toggleDropdown() {
      if (this.plan.hasClass('is_dropdown_open')) {
        this.plan.removeClass('is_dropdown_open');
        this.planDropdown.removeClass('is_dropdown_open');
        this.body.off('click');
        this.planValidation();
      } else {
        this.plan.addClass('is_dropdown_open');
        this.planDropdown.addClass('is_dropdown_open');
        this.body.on('click', (e) => {
          this.toggleDropdown();
        });
      }
    }

    selectDropdownItem(target) {
      if (this.planKey == target.dataset.planKey) {
        return;
      }
      var jqTarget = $(target);
      this.planDropdownItems.removeClass('is_selected');
      jqTarget.addClass('is_selected');
      this.planKey = target.dataset.planKey;
      this.plan.val(target.dataset.planName);
      this.toggleDropdown();
    }
  }


  new EducationApply();
}
